import { MenuItemType } from '../../components/select/select';

export const ALL_HEALTH_SYSTEMS: MenuItemType = {
  label: 'All Health Systems',
  value: ''
};

export const DEFAULT_HEALTH_SYSTEM = ALL_HEALTH_SYSTEMS.value;
